module.exports = __webpack_public_path__ + "static/media/7.500017b9.jpg";